// @flow

export const MAX_NUMBER_SEARCH_RESULT_PER_PAGE = 25;

export const NUMBER_SEARCH_TERM_SUGGESTIONS = 10;

export const NUMBER_PRODUCT_SUGGESTIONS = 10;

export const NUMBER_PRODUCT_SUGGESTIONS_PER_PAGE = 20;

export const DEFAULT_SEARCH_PANEL_BLOCK = {
  products: {
    label: 'AdminHTML.SearchPageDisplay.Constants.searchPanelBlock_Products',
    pageSize: 25,
    active: true,
    displayImage: true
  },
  collections: {
    label: 'AdminHTML.SearchPageDisplay.Constants.searchPanelBlock_Collections',
    pageSize: 25,
    active: false,
    displayImage: false, // true or false
    displayDescription: false,
    excludedValues: []
  },
  pages: {
    label: 'AdminHTML.SearchPageDisplay.Constants.searchPanelBlock_Pages',
    pageSize: 25,
    active: false,
    displayImage: false, // true or false
    displayExcerpt: false
  },
  searchEmptyResultMessages: {
    active: true,
    label: 'AdminHTML.SearchPageDisplay.Constants.searchPanelBlock_NoResultMessage'
  },
  searchTips: {
    label: 'AdminHTML.SearchPageDisplay.Constants.searchPanelBlock_SearchTips',
    active: false,
    searchTips: 'AdminHTML.SearchPageDisplay.Constants.searchPanelBlock_SearchTips_Message'
  },
  searchTermSuggestions: {
    label: 'AdminHTML.SearchPageDisplay.Constants.searchPanelBlock_SearchTermSuggestions',
    active: false,
    type: 'based_on_data', // based_on_data or manually
    backup: [],
    searchTermList: []
  },
  mostPopularProducts: {
    label: 'AdminHTML.SearchPageDisplay.Constants.searchPanelBlock_PopularProducts',
    active: false,
    type: 'based_on_data', // based_on_data or manually
    backup: [],
    productList: []
  }
};

export const SEARCH_TERM_LIST = [
  {
    value: 'based_on_data',
    label: 'AdminHTML.SearchPageDisplay.NoSearchResultsPage.searchTerm_RadioButton1_Label',
    tooltip: 'AdminHTML.SearchPageDisplay.NoSearchResultsPage.searchTerm_RadioButton1_Tooltip'
  },
  {
    value: 'manually',
    label: 'AdminHTML.SearchPageDisplay.NoSearchResultsPage.searchTerm_RadioButton2_Label'
  }
];

export const PRODUCT_LIST = [
  {
    value: 'based_on_data',
    label: 'AdminHTML.SearchPageDisplay.NoSearchResultsPage.popularProduct_RadioButton1_Label',
    tooltip: 'AdminHTML.SearchPageDisplay.NoSearchResultsPage.popularProduct_RadioButton1_Tooltip'
  },
  {
    value: 'manually',
    label: 'AdminHTML.SearchPageDisplay.NoSearchResultsPage.popularProduct_RadioButton2_Label'
  }
];
